export default __webpack_public_path__ + "static/media/project-video.95ead3ba.svg";